import { render, staticRenderFns } from "./v-card-panel.vue?vue&type=template&id=855cd6b2"
import script from "./v-card-panel.vue?vue&type=script&lang=js"
export * from "./v-card-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports